import React from 'react'
import { useContent } from '../../services'
import Bredcom from '../Bredcrumb/Main'
import Book from '../../components/Menhome/Book'
import PageSEO from '../SEO/PageSEO'
import Img from '../../assets/images/background/banner-image-3.jpg'

const BREADCRUMB_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://www.huqup380.com/' },
    { '@type': 'ListItem', position: 2, name: 'Reservation', item: 'https://www.huqup380.com/reservation' }
  ]
}

function Main() {
  const { data, loading } = useContent('reservationContent');

  if (loading || !data) return null;

  const { breadcrumb } = data;

  return (
    <>
      <PageSEO
        title="Book a Table"
        description="Reserve your table at Huq Up - Cafe & Grill in Little Elm, TX. Open daily from 11 AM. Call (469) 724-1846 or book online."
        canonical="https://www.huqup380.com/reservation"
        structuredData={BREADCRUMB_SCHEMA}
      />
      <Bredcom subtitle={breadcrumb.subtitle} title={breadcrumb.title} Img={Img} />
      <Book />
    </>
  )
}

export default Main
